let isMessageLocked = false;

export const lockMessage = () => {
  isMessageLocked = true;
};

export const unlockMessage = () => {
  isMessageLocked = false;
};

export const isLocked = () => isMessageLocked;
